<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible="visible"
      :title="title || '面料批量上架'"
      :wrapperClosable="false"
      direction="rtl"
      size="1000px"
      @close="cancel()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :treeData="treeData"
          :dataList="dataList"
          :isSingle="isSingle"
          @close="close()"
        />
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    isSingle: { type: Boolean, default: false },
    title: { type: String, default: '' },
    dataList: { type: Array, default: () => [] },
    treeData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    close() {
      this.cancel()
      this.$emit('reload')
    },
    cancel() {
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 32px;
}
</style>
